// @flow
import './Form.css';

import * as React from 'react';
import _ from 'lodash';

import HighlightText from '../HighlightText';
import ExpandButton from '../ExpandButton';
import Button from '../Button';
import MetadataInputComponent from '../../components/metadata/MetadataInputComponent';
import DatePicker from '../../common/form/DatePicker';
import classNames from 'classnames';
import Action from '../Action';
import { ThemeSetup } from '../../themes/ThemeSetup';
import t from '../../i18n/I18n';
//Components.MetadataInputComponent = MetadataInputComponent;
//Components.DatePicker = DatePicker;

type Props = {
  fields: Object[],
  className?: string,
  pattern?: string,
  searchType?: 'KEYS' | 'VALUES' | 'ALL',
  showTimeline?: boolean,
  disabled?: boolean,
  onChange: Function,
  onLocateClick?: Function,
  onDelete?: Function
};

type State = {
  collapsedSubfields: Object
};

function hasStartStopFields(field: Object) {
  if (!(field && field.__data)) {
    return false;
  }

  const keys = Object.keys(field.__data);
  return _.includes(keys, 'startTimeMs') && _.includes(keys, 'stopTimeMs');
}

function normalizeEventArgs(...args: any[]) {
  const event: Event = args[0];
  if (typeof event !== 'object') {
    args[0] = { target: { value: event } };
  }

  return args;
}

export default class Form extends React.Component<Props, State> {
  static Types = {
    SUBFIELD: 'Subfield',
    TEXT: 'TextBox',
    AUTOCOMPLETE: 'AutocompleteTextBox',
    DROPDOWN: 'Dropdown',
    METADATA: 'MetadataInputComponent',
    DATE: 'DatePicker'
  };

  static defaultProps = {
    className: ''
  };

  static _currentTabIndex: number = 0;

  state = {
    collapsedSubfields: {}
  };

  onToggle = (key: string) => {
    const collapsedSubfields = { ...this.state.collapsedSubfields };
    if (collapsedSubfields[key]) {
      delete collapsedSubfields[key];
    } else {
      collapsedSubfields[key] = true;
    }
    this.setState({ collapsedSubfields });
  };

  wrapOnChange = (field: Object) => {
    return (...args: any[]) => {
      const normalizedArgs = normalizeEventArgs(...args);
      return this.props.onChange(...normalizedArgs, field);
    };
  };

  renderField = (field: Object, i: number) => {
    if (!field) {
      return null;
    }

    const { collapsedSubfields } = this.state;
    const { pattern, searchType, showTimeline, disabled, onChange, onLocateClick, onDelete } = this.props;
    const { type, label, value, invalid, hideLabel, ...rest } = field;

    const isExpanded = !collapsedSubfields[field.label];
    if (type === Form.Types.SUBFIELD) {
      const showLocateBtn = hasStartStopFields(field);
      return (
        <div key={i} className="subfield">
          <header>
            <ExpandButton isExpanded={isExpanded} onClick={() => this.onToggle(field.label)} />
            <label className="formfield-label">{label || 'Object'}</label>
            {showTimeline && showLocateBtn && onLocateClick ? (
              <Button type="PLAIN" className="locate" text={t('LOCALTE_ON_TIMELINE')} onClick={() => onLocateClick(field)} />
            ) : null}
          </header>
          {isExpanded ? <div className="subfield-body">{field.fields.map(this.renderField)}</div> : null}
        </div>
      );
    }

    const Component = Components[type];
    console.log(Component);
    if (!Component) {
      throw new Error(`No input component found for type ${type}`);
    }

    const text = pattern && searchType !== 'VALUES' ? <HighlightText text={label} pattern={pattern} /> : label;

    const tabIndex = ++Form._currentTabIndex;

    let props;
    if (onChange) {
      props = {
        value,
        tabIndex,
        disabled,
        onChange: this.wrapOnChange(field)
      };
    } else {
      props = { disabled, defaultValue: value, tabIndex };
    }
    return (
      <div key={i} className="formfield">
        <Action custom predicates={[() => !hideLabel]}>
          <label className="formfield-label">{text}</label>
        </Action>
        <div className={classNames('formfield-input', { invalid: invalid })}>
          <Component {...props} {...rest} />
        </div>
        <Action custom predicates={[() => i === 0 && _.isFunction(onDelete)]}>
          <img src={ThemeSetup.getImageURL('trash_red.svg')} onClick={onDelete} className="delete-button" />
        </Action>
      </div>
    );
  };

  render() {
    const { fields, className } = this.props;
    return (
      <div name="Form" className={className}>
        {fields.map(this.renderField)}
      </div>
    );
  }
}
